<template lang="pug">
  .financialInputs
    el-radio-group(
      v-bind:value="financialAssumptionsSwitch"
      v-on:input="$emit('switchChange', $event)"
    )
      el-radio-button(label="Base Case")
      el-radio-button(label="Spot Case")
      el-radio-button(label="User Case")
    slider(
      v-if="!ignore.includes('goldPrice')"
      :min="1000"
      :step="25"
      :max="3000"
      v-model='financialInputs.goldPrice'
      title='Gold Price (US$/oz)'
      :baseValue='baseCaseFinancialAssumptions.goldPrice'
      :hide='true'
    )
    slider(
      v-if="!ignore.includes('silverPrice')"
      :min="10"
      :step="0.25"
      :max="30"
      v-model='financialInputs.silverPrice'
      title='Silver Price (US$/oz)'
      :baseValue='baseCaseFinancialAssumptions.silverPrice'
      :hide='true'
      :precision='2'
    )
    slider(
      v-if="!ignore.includes('copperPrice')"
      :min="4000"
      :step="100"
      :max="10000"
      v-model='financialInputs.copperPrice'
      title='Copper Price (US$/t)'
      :baseValue='baseCaseFinancialAssumptions.copperPrice'
      :hide='true'
      :precision='0'
    )
    slider(
      v-if="!ignore.includes('molybdenumPrice')"
      :min="10000"
      :step="1000"
      :max="30000"
      v-model='financialInputs.molybdenumPrice'
      title='Molybdenum Price (US$/t)'
      :baseValue='baseCaseFinancialAssumptions.molybdenumPrice'
      :hide='true'
      :precision='0'
    )
    slider(
      v-if="!ignore.includes('rheniumPrice')"
      :min="1000000"
      :step="100000"
      :max="5000000"
      v-model='financialInputs.rheniumPrice'
      title='Rhenium Price (US$/t)'
      :baseValue='baseCaseFinancialAssumptions.rheniumPrice'
      :hide='true'
      :precision='0'
    )
    slider(
      v-if="!ignore.includes('discountRate')"
      :min="0"
      :step="0.01"
      :max="0.15"
      v-model='financialInputs.discountRate'
      title='Discount Rate (%)'
      :hide='false'
      type="percent"
      :precision='3'
    )
    slider(
      v-if="!ignore.includes('delayStartYear')"
      :min="0"
      :step="1"
      :max="5"
      v-model='financialInputs.delayStartYear'
      title='Delay Start Year'
      :hide='false'
    )
    slider(
      v-if="!ignore.includes('USDCAD')"
      :min="0.65"
      :step="0.01"
      :max="1.65"
      v-model='financialInputs.USDCAD'
      title='FX Rate (USD:CAD)'
      :hide='false'
      :precision='2'
    )
</template>

<script>
import Slider from '@/components/slider'

export default {
  name: 'FinancialInputs',
  props: {
    financialInputs: {},
    baseCaseFinancialAssumptions: {},
    financialAssumptionsSwitch: {},
    ignore: {
      default: function () { return [] }
    }
  },
  components: { Slider },
  data: function () {
    return {
    }
  }
}
</script>

<style scoped lang="stylus">

</style>
